
export interface Vessel {
  id: number;
  fleet_name: string;
  imoNumber: string;
  mmsi?: string;
  call_sign?: string;
  flag?: string;
  classes?: string;
  area?: string;
  dwt?: string;
  vesselType: string;
  companyAdmin: Company;
  companyGroupAdmin?: CompanyAdmin;
  active: boolean;
}

export interface Company {
  id: number;
  uid: {
    username: string;
    password: string;
    role: {
      id: number;
      roleType: string;
    };
    enabled: boolean;
  };
  cga: {
    id: number;
    name: string;
  };
  name: string;
  contactNo?: string;
  altContactNo?: string;
  email?: string;
  addressLine1: string;
  addressLine2: string;
  landmark: string;
  country: string;
  state: string;
  city: string;
  companyDetails: string;
  active: boolean;
  username?: string;
  password?: string;
};

export interface CompanyAdmin {
  id: number;
  name: string;
}

/**
 * A single port-to-port movement (Leg) within a parent Voyage.
 * Legs are ordered by sequenceNumber ascending within their voyage.
 */
export interface Leg {
  id: number
  voyageId: number
  sequenceNumber: number
  departurePort: string
  /** Optional — may not be known at leg creation time. */
  arrivalPort?: string
  legStartDate?: string
  legEndDate?: string
  status?: string
  active?: boolean
  etd?: string
  cosp?: string
  eosp?: string
  arrivalFew?: string
  eta?: string
  estimatedDistance?: number
  displacement?: number
  draftFore?: number
  draftMid?: number
  draftAft?: number
  totalCargoOnboard?: number
  loadingCondition?: string
  cpSpeed?: number
  cpConsumptionTotal?: number
  agentName?: string
  agentContactNumber?: string
  agentTelephoneNumber?: string
  agentFaxAddress?: string
  agentEmail?: string
  reportCount?: number
}

export interface Voyage {
  id: number
  voyageNumber: string
  /**
   * User-supplied chartered voyage number — optional, alphanumeric + special chars.
   * Coexists with the system-generated voyageNumber.
   */
  charteredVoyageNumber?: string
  departurePort: string
  /** Optional — N/A is no longer a valid value; use undefined/null instead. */
  arrivalPort?: string
  startDate: string
  endDate: string
  companyGroupAdminId: number
  companyAdminId: number
  vessel: {
    id: number
    fleet_name: string
    vesselType: string
    imoNumber: string
  }
  active: boolean
  status?: string
  loadingCondition?: string
  agentName?: string
  agentContactNumber?: string
  agentTelephoneNumber?: string
  agentFaxAddress?: string
  agentEmail?: string
  reportCount?: number
  /** Ordered legs within this voyage — populated on GET responses. */
  legs?: Leg[]
}


export interface CreatedReports {
  id: number;
  reportType: string;
  status: ReportStatus;
  createdDateTime: Date;
  submittedDateTime: Date;
  reportDateTime?: string;
  remark: string;
  createdBy: {
    id: number;
    rank: string;
  };
  assignment: {
    id: number;
    template: {
      id: number;
      name: string;
      menus: {
        name: string;
        id: number;
        isActive: boolean;
        submenus: Submenu[];
      }[];
    };
    customTemplate: {
      id: number;
      menus: {
        name: string;
        id: number;
        isActive: boolean;
        submenus: Submenu[];
      }[];
    }
  };
  values: {
    field: number;
    reportId?: number;
    report?: number;
    label: string;
    valueText: string;
  }[];
  vesselType: string;
  vesselId: number;
  voyage?: number;
  voyageDto?: Voyage;
  voyageNumber?: string;
  legId?: number;
  legSequenceNumber?: number;
  legDto?: Leg;
  leg?: Leg;
}

export interface ReportAttachment {
  id: number;
  reportId: number;
  documentName?: string | null;
  remarks?: string | null;
  fileName: string;
  fileType?: string | null;
  fileSize?: number | null;
  createdAt?: string | null;
}

export interface AssignedReports {
  id: number;
  companyAdmin: number;
  template: {
    id: number;
    name: string;
    vesselType: string | null;
    vessel: {
      id: number;
      name: string;
      imoNumber?: string;
    } | null;
    menus: {
      name: string;
      id: number;
      isActive: boolean;
      submenus: Submenu[];
    }[];
  };
  customTemplate: {
    id: number;
    masterTemplateId: number;
    menus: {
      name: string;
      id: number;
      isActive: boolean;
      submenus: Submenu[];
    }[];
  }
  vesselType: string;
  vessel: number;
  companyGroupAdmin: number;
}

export interface CustomAssignedReports {
  id: number;
  template: {
    id: number;
    name: string;
    vesselType: string | null;
    vessel: {
      id: number;
      name: string;
      imoNumber?: string;
    } | null;
  };
  companyAdmin: {
    id: number;
  };
  vesselType: string;
  vesselId: number;
  menus: {
    name: string;
    id: number;
    isActive: boolean;
    submenus: Submenu[];
  }[]; // 👈 Changed to an array
  masterTemplate: {
    id: number;
    name: string;
  }
}

export interface Template {
  id: number;
  name: string;
  description: string;
  // menus: Menu[];
}

export interface Reports {
  id: number;
  name: string;
  order: number;
  templateId: number;
  isActive: boolean;
  submenus: Submenu[];
  customTemplateId?: number;
}

export interface Submenu {
  id: number;
  name: string;
  isActive: boolean;
  fields: Fields[];
  menuId: number;
  // add any other submenu fields you need here
}

export interface Fields {
  id: number;
  label: string;
  fieldType: string;
  readOnly: boolean;
  isActive: boolean;
  order?: number;
  optionsJson?: string[];
  value?: string | number | string[];
  required: boolean;
  unit?: string;
  minValue?: number;
  maxValue?: number;
  warningOnly?: WarningLevel;
  submenuId: number
}

export enum WarningLevel {
  STRICT = "STRICT",
  SOFT = "SOFT"
}

export enum ReportStatus {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED"
}

//for new position report page

export interface CompanyAdmin {
  id: number;
  uid: {
    username: string;
    password: string;
    role: {
      id: number;
      roleType: string;
    };
    enabled: boolean;
  };
  cgaid: {
    id: number;
  };
  name: string;
  contactNo: string;
  altContactNo: string;
  email: string;
  addressLine1: string;
  addressLine2: string;
  landmark: string;
  country: string;
  state: string;
  city: string;
  companyDetails: string;
  active: boolean;
};

// === Vessel Operations (header strip) ===
export interface VesselOperations {
  vesselName: string;
  vesselImo: string;
  lastPort: string | null;
  atd: string | null;     // ISO string or null
  nextPort: string | null;
  eta: string | null;     // ISO string or null
  latitude: string | null;
  longitude: string | null;
  status: string | null;
  lastUpdated: string | null;
  latLongSource: string | null;
  masterName: string | null;
  masterContactNumber: string | null;
  chiefEngineerName: string | null;
}

// === Cargo Operations ===
export type CargoBreakupType = 'TANK' | 'HOLD';
export type CargoOperationStatus = 'DRAFT' | 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED';

export interface CargoFinalAttachment {
  id?: number;
  cargoOperationId?: number;
  documentName: string;
  remarks?: string | null;
  attachmentUrl?: string | null;
}

export interface CargoOperationDetail {
  id?: number;
  cargoOperationId?: number;
  cargoGrade?: string | null;
  cargoName: string;
  quantityMt?: number | null;
  metricTonInAir?: number | null;
  noOfLoadersOrDischarge?: number | null;
  ballastPumpingRateM3PerHr?: number | null;
  dockWaterDensity?: number | null;
  maxDraughtAvailableHw?: number | null;
  loadDischargeRateM3PerHr?: number | null;
  loadDischargeRateUnit?: string | null;
  currentDraughtMtrs?: number | null;
  attachmentUrl?: string | null;
  orderIndex?: number;
}

export interface CargoOperation {
  id?: number;
  companyId?: number | null;
  companyName?: string | null;
  vesselId?: number | null;
  vesselName?: string | null;
  voyageId?: number | null;
  voyageNumber?: string | null;
  legId?: number | null;
  legSequenceNumber?: number | null;
  legDeparturePort?: string | null;
  legArrivalPort?: string | null;
  breakupType: CargoBreakupType;
  status?: CargoOperationStatus;
  vesselType?: string | null;
  remarks?: string | null;
  approvalComments?: string | null;
  approvedById?: number | null;
  approvedByName?: string | null;
  approvedDateTime?: string | null;
  submittedById?: number | null;
  submittedByName?: string | null;
  submittedDateTime?: string | null;
  cargoName?: string | null;
  totalCargoQtyMt?: number | null;
  shipperAsPerBl?: string | null;
  receiverAsPerBl?: string | null;
  loadPorts?: string | null;
  dischargePorts?: string | null;
  heatingRequirements?: string | null;
  createdDateTime?: string;
  updatedDateTime?: string;
  details: CargoOperationDetail[];
  finalAttachments?: CargoFinalAttachment[];
}

export interface CargoOperationRequest {
  companyId?: number | null;
  vesselId?: number | null;
  voyageId?: number | null;
  legId?: number | null;
  breakupType: CargoBreakupType;
  status?: CargoOperationStatus;
  vesselType?: string | null;
  remarks?: string | null;
  cargoName?: string | null;
  totalCargoQtyMt?: number | null;
  shipperAsPerBl?: string | null;
  receiverAsPerBl?: string | null;
  loadPorts?: string | null;
  dischargePorts?: string | null;
  heatingRequirements?: string | null;
  details: CargoOperationDetail[];
  finalAttachments?: CargoFinalAttachment[];
}
